import { render, staticRenderFns } from "./delivery-bar-chart.vue?vue&type=template&id=4e496b05&scoped=true&"
import script from "./delivery-bar-chart.vue?vue&type=script&lang=js&"
export * from "./delivery-bar-chart.vue?vue&type=script&lang=js&"
import style0 from "./delivery-bar-chart.vue?vue&type=style&index=0&id=4e496b05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e496b05",
  null
  
)

export default component.exports